import { IoMdSearch } from 'react-icons/io';
import { InputBase } from '../../../../componentsNew/Input/InputBase';
import { CardDash } from '../CardDash';
import { useEffect, useState } from '@wordpress/element';
import { removerArtigoDuplicado } from '@hooks/Analises/auxiliares';
import Select from '../../../../componentsNew/Select';
import { MdExpandMore } from 'react-icons/md';

export function SearchPorPalavraChave({
  metricasPaginadas,
  setMetricasFiltradas,
  onChange = () => {},
  className,
  filtros,
  artigo = false,
  setQtdeArtigos = () => {},
}) {
  const [filtro, setFiltro] = useState('');
  const [placeholderValue, setPlaceholderValue] = useState(filtros ? 'title' : 'palavra');

  useEffect(() => {
    onChange();
    let unicos = artigo
      ? removerArtigoDuplicado(metricasPaginadas || [])
      : metricasPaginadas || [];
    setQtdeArtigos(unicos?.length);

    if (Array.isArray(unicos)) unicos?.sort((a, b) => a?.titulo?.localeCompare(b.titulo));

    if (filtro.length == 0) setMetricasFiltradas(unicos);
    else
      setMetricasFiltradas(
        unicos?.filter(m => m[placeholderValue]?.toLowerCase().includes(filtro.toLowerCase()))
      );
  }, [filtro, metricasPaginadas]);

  return (
    <div className="flex items-center ">
      <InputBase
        component="search"
        classNameInput={filtros && 'rounded-l-lg border-r-0'}
        label="Pesquise pela palavra-chave"
        className={className}
        icon={<IoMdSearch className="w-5 h-5 relative text-text-tertiary" />}
        value={filtro}
        onChange={e => setFiltro(e.target.value)}
      />

      {filtros && (
        <div className="border-y border-solid border-divider h-[2.406em] flex items-center ">
          <div className="bg-divider w-[1px] h-8"></div>
        </div>
      )}
      {filtros && (
        <div className="w-52 flex items-center">
          <Select
            valorInput={placeholderValue}
            setValorInput={setPlaceholderValue}
            icon={<MdExpandMore className="w-5 h-5 relative text-text-primary" />}
            component="search"
            classNameInput="rounded-r-lg border-l-0"
            opcoes={[
              { valor: 'keyword', titulo: 'Buscar por palavra-chave' },
              { valor: 'title', titulo: 'Buscar por título' },
            ]}
          />
        </div>
      )}
    </div>
  );
}
